<template>
    <div class="modal-background"></div>
    <div class="modal-container">
        <div>
            <img style="width: 60%; margin-top: 20px;"
                :src="modalParceria === false ? '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/d0a11bfa-fa31-4d2b-b77d-6c3d3b1a3b30.svg' : '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/7071f3aa-8dd5-436b-8e16-e3fceee6e446.svg'"
                alt="" class=" modal-img" />
            <p class="modal-title">{{ modalParceria === false ? 'Parece que todos os campos e documentos foram preenchidos.' : 'A Vivo tem um recado importante para você' }}</p>
            <p v-if="!ok && modalParceria" class="modal-subtitle">Agora que já finalizamos o seu cadastro,<br><b>é super importante que sua parceira gestante também realize-o</b>
                para ter acesso a todos os benefícios oferecidos pelo Programa Vivo Mais Família, e para isso,<b>ela deve acessar este mesmo portal e realizar o cadastro na opção "sou gestante".</b></p>
            <p v-else-if="!ok && !modalParceria" class="modal-subtitle">Vamos verificar seus dados e caso haja alguma irregularidade, entraremos em contato,
                ok? <br>
                Mesmo durante esse período de conferência, seu programa já fica pré-aprovado e acessível.</p>
            <div v-else>
                <p class="modal-subtitle"> Estamos fazendo seu redirecionamento para o programa.
                ok? <br>
                Mesmo durante esse período de conferência, seu programa já fica pré-aprovado e acessível.</p>
                <v-progress-circular
                indeterminate
                color="#7A00E6"
                v-if="ok"
                :size="70"
                :width="7"
                ></v-progress-circular>
            </div>
            <v-btn v-if="!ok" color="#660099" @click="modalParceria === false ? loginToVideo() : modalParceria = !modalParceria" class="text-none btn-action">{{ modalParceria === false ? 'Confirmar' : 'Entendi' }}</v-btn>
        </div>
    </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, onMounted } from 'vue';
import { useFelixBagAuxStore } from '../../../../store';
import requestApi from '@/utils/requestApi';
defineEmits(["confirmar"])

const felixBagAuxStore = useFelixBagAuxStore();
let ok = ref(false);
const props = defineProps(['cpf'])
const profileName = ref('')
const modalParceria = ref(false)

onMounted(() => {
  profileName.value = felixBagAuxStore.form.profile.name
  console.log("Modal Profile name é: ", profileName)
  checkModalParceria()
});

function checkModalParceria() {
    if (profileName.value === 'parceria') {
        modalParceria.value = true
    }
}

function loginToVideo() {
    ok.value = true
    requestApi({
      url: `/v3/healthbit/get_short_url`,
      method: "post",
      headers: {
        'Videobot-Token': localStorage.getItem('TOKEN_VIDEOBOT')
      },
      data: {
        "viewer_id": props.cpf
      }
    }).then(response => {
      window.open(response.data.short_url, '_self');
    })
}

</script>

<style scoped>
.modal-background {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 5;
    background-color: black;
    opacity: 0.4;
}

.modal-container {
    width: 85%;
    position: absolute;
    top: 15%;
    left: 7.5%;
    border-radius: 12px;
    padding: 20px 0;
    background-color: #fff;

    text-align: center;
    z-index: 5;
}

.modal-title {
    color: #464646;
    font-weight: bold;
    width: 90%;
    font-size: 13px;
    margin-left: 5%;
}

.modal-subtitle {
    font-size: 10px;
    width: 90%;
    margin-left: 5%;
    margin-bottom: 20px;
}

.modal-container .btn-action {
    width: 90%;
    font-size: 13px;
}
</style>